import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemServiceRequestEmbedRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-service-request-embed',
	path: '/jira/servicedesk/service-requests/:issueKey(\\w+-\\d+)/embed',
	exact: true,
};
